import { Button, styled } from '@ltvco/refresh-lib/theme';

export const BreadcrumbBackButton = styled(Button)({
  minWidth: 0,
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'transparent !important',
  },
});
